<template>
  <div class="view-control-box">
    <div class="view-components-box"
         :is="showComponents"
         :bannedControl="bannedControl"
         :poster="poster" 
         :isWaiting="isWaiting"
         :isPause="isPause"
         :times="times"
         :duration="duration"
         :isFull="isFull"
         :showClose="showClose"
         :showSwitchAudio="showSwitchAudio"
         :clearScreen="clearScreen"
         :hideControls="hideControls"
         :progressPoint="progressPoint"
         :tryWatchTime="tryWatchTime"
         @progressChange="getPlayProgressInfo"
         @clickInfo="getComponentsClickInfo">
    </div>
  </div>
</template>

<script>
// 组件 start
import audioNormalView from './audio/audio_view_normal';
import videoNormalView from './video/video_view_normal';
// 组件 end

export default {
  props: {
    viewType: [String],
    // 视频信息 start
    poster: [String],
    bannedControl: [Boolean],
    isWaiting:[Boolean],
    isPause: {
      type: Boolean,
      default: true,
    },
    times: [String],
    duration: [String],
    isFull: [Boolean],
    showClose: [Boolean],
    showSwitchAudio: [Boolean],
    clearScreen: [Boolean],
    hideControls: [Boolean],
    progressPoint: [Number], // 0 - 1
    tryWatchTime: [Number, String]
    // 视频信息 end
  },
  components: {
    audioNormalView,
    videoNormalView,
  },
  data(){
    return {
      showComponents: null,
    }
  },
  watch: {
    viewType: function() {
      this.setShowCompontens();
    },
  },
  mounted() {
    this.setShowCompontens();
  },
  methods: {
    setShowCompontens: function() {
      this.showComponents = this.viewType || 'videoNormalView';
    },
    // 视图 start
    getPlayProgressInfo: function(progress) {
      this.sendProgressStatus(progress);
    },
    getComponentsClickInfo: function(clickInfo) {
      this.sendClickControlInfo(clickInfo);
    },
    // 视图 end
    sendProgressStatus: function(progress) {
      this.$emit('progressChange',progress)
    },
    sendClickControlInfo: function(clickInfo) {
      this.$emit('clickInfo',clickInfo);
    },
  },
};
</script>

<style lang="less">
  .view-control-box {
    height: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/video_player/view/view_control.vue